import { useCallback } from "react";
import axios from "axios";
import { useAuth } from "@clerk/react";
import { format } from "date-fns";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useApi() {
  const { getToken } = useAuth();
  return useCallback(
    async (method, url, data) => {
      const token = await getToken();
      const res = await axios({ method, url: `${API}${url}`, data, headers: { Authorization: `Bearer ${token}` } });
      return res.data;
    },
    [getToken],
  );
}

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return d || e?.message || "Something went wrong";
};

const eur = new Intl.NumberFormat("en-IE", { style: "currency", currency: "EUR" });
export const fmtEur = (v) => eur.format(v || 0);

export const fmtHours = (minutes) => {
  const m = Math.round(minutes || 0);
  const h = Math.floor(m / 60);
  const r = m % 60;
  return r ? `${h}h ${String(r).padStart(2, "0")}m` : `${h}h`;
};

export const monthKey = (d) => format(d, "yyyy-MM");

export const toMin = (t) => {
  const [h, m] = t.split(":").map(Number);
  return h * 60 + m;
};

export const spanMinutes = (start, end) => {
  const s = toMin(start) ;
  const e = toMin(end);
  return e - s > 0 ? e - s : e - s + 1440;
};
